import { render, staticRenderFns } from "./member_pc.vue?vue&type=template&id=60830d12&scoped=true&"
import script from "./member_pc.vue?vue&type=script&lang=js&"
export * from "./member_pc.vue?vue&type=script&lang=js&"
import style0 from "./member_pc.vue?vue&type=style&index=0&id=60830d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60830d12",
  null
  
)

export default component.exports